import { render, staticRenderFns } from "./SectionWidget.vue?vue&type=template&id=d066dc2c&scoped=true"
import script from "./SectionWidget.vue?vue&type=script&lang=js"
export * from "./SectionWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d066dc2c",
  null
  
)

export default component.exports